
    (function () {
      if (window.__grenadinePrestationPrefsInstalled) { return; }
      window.__grenadinePrestationPrefsInstalled = true;

      var PREF_FIELDS = [
        { name: "properties[À l'abri des regards]", key: "À l'abri des regards" },
        { name: 'properties[Mobilité réduite]', key: 'Mobilité réduite' }
      ];

      function isCartAddUrl(url) {
        return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      }

      function getCheckedPrefs() {
        var result = {};
        PREF_FIELDS.forEach(function (field) {
          var el = document.getElementsByName(field.name)[0];
          if (el && el.checked) {
            result[field.key] = 'Oui';
          }
        });
        return result;
      }

      function injectIntoFormData(formData, prefs) {
        for (var key in prefs) {
          if (Object.prototype.hasOwnProperty.call(prefs, key)) {
            var propKey = 'properties[' + key + ']';
            if (!formData.has(propKey)) {
              formData.append(propKey, prefs[key]);
            }
          }
        }
      }

      function applyPrefsToItem(item, prefs) {
        item.properties = item.properties || {};
        for (var key in prefs) {
          if (Object.prototype.hasOwnProperty.call(prefs, key) && !(key in item.properties)) {
            item.properties[key] = prefs[key];
          }
        }
      }

      function injectIntoJsonBody(bodyString, prefs) {
        var payload;
        try {
          payload = JSON.parse(bodyString);
        } catch (e) {
          return null;
        }
        if (payload && Array.isArray(payload.items)) {
          payload.items.forEach(function (item) { applyPrefsToItem(item, prefs); });
        } else if (payload && payload.id !== undefined) {
          applyPrefsToItem(payload, prefs);
        } else {
          return null;
        }
        return JSON.stringify(payload);
      }

      var prevFetchForPrefs = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';

        if (isCartAddUrl(url) && String(method).toUpperCase() === 'POST' && init && init.body) {
          var prefs = getCheckedPrefs();
          if (Object.keys(prefs).length > 0) {
            if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
              injectIntoFormData(init.body, prefs);
            } else if (typeof init.body === 'string') {
              var newBody = injectIntoJsonBody(init.body, prefs);
              if (newBody) { init.body = newBody; }
            }
          }
        }

        return prevFetchForPrefs.call(this, input, init);
      };

      if (window.XMLHttpRequest && !window.__grenadinePrestationPrefsXhrPatched) {
        window.__grenadinePrestationPrefsXhrPatched = true;
        var OriginalPrefsXhrOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          this.__grenadineIsCartAddForPrefs = isCartAddUrl(url) && String(method).toUpperCase() === 'POST';
          return OriginalPrefsXhrOpen.apply(this, arguments);
        };
        var OriginalPrefsXhrSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (body) {
          if (this.__grenadineIsCartAddForPrefs && body) {
            var prefs = getCheckedPrefs();
            if (Object.keys(prefs).length > 0) {
              if (typeof FormData !== 'undefined' && body instanceof FormData) {
                injectIntoFormData(body, prefs);
              } else if (typeof body === 'string') {
                var newBody = injectIntoJsonBody(body, prefs);
                if (newBody) { body = newBody; }
              }
            }
          }
          return OriginalPrefsXhrSend.call(this, body);
        };
      }
    })();
  
;
    (function () {
      if (window.__grenadineApptTimerInstalled) { return; }
      window.__grenadineApptTimerInstalled = true;

      var EXPIRY_PROP_KEY = '_grenadine_appt_expires_at';
      var HOLD_DURATION_MS = 300000;

      function isCartAddUrl(url) {
        return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      }

      function payloadHasMeetyProperty(properties) {
        if (!properties) { return false; }
        for (var key in properties) {
          if (Object.prototype.hasOwnProperty.call(properties, key)) {
            var lower = key.toLowerCase();
            if (lower.indexOf('_meety_') === 0 || lower.indexOf('date et horaire') !== -1) {
              return true;
            }
          }
        }
        return false;
      }

      function injectExpiryIntoFormData(formData) {
        var properties = {};
        var iterator = formData.entries();
        var step = iterator.next();
        while (!step.done) {
          var key = step.value[0];
          var match = /^properties\[(.+)\]$/.exec(key);
          if (match) { properties[match[1]] = step.value[1]; }
          step = iterator.next();
        }
        if (payloadHasMeetyProperty(properties) && !formData.has('properties[' + EXPIRY_PROP_KEY + ']')) {
          formData.append('properties[' + EXPIRY_PROP_KEY + ']', String(Date.now() + HOLD_DURATION_MS));
        }
      }

      function applyExpiryToItem(item) {
        item.properties = item.properties || {};
        if (payloadHasMeetyProperty(item.properties) && !(EXPIRY_PROP_KEY in item.properties)) {
          item.properties[EXPIRY_PROP_KEY] = String(Date.now() + HOLD_DURATION_MS);
        }
      }

      function injectExpiryIntoJsonBody(bodyString) {
        var payload;
        try {
          payload = JSON.parse(bodyString);
        } catch (e) {
          return null;
        }
        if (payload && Array.isArray(payload.items)) {
          payload.items.forEach(applyExpiryToItem);
        } else if (payload && payload.id !== undefined) {
          applyExpiryToItem(payload);
        } else {
          return null;
        }
        return JSON.stringify(payload);
      }

      var prevFetchForApptTimer = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';

        if (isCartAddUrl(url) && String(method).toUpperCase() === 'POST' && init && init.body) {
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            injectExpiryIntoFormData(init.body);
          } else if (typeof init.body === 'string') {
            var newBody = injectExpiryIntoJsonBody(init.body);
            if (newBody) { init.body = newBody; }
          }
        }

        return prevFetchForApptTimer.call(this, input, init);
      };

      if (window.XMLHttpRequest && !window.__grenadineApptTimerXhrPatched) {
        window.__grenadineApptTimerXhrPatched = true;
        var OriginalApptXhrOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          this.__grenadineIsCartAddForApptTimer = isCartAddUrl(url) && String(method).toUpperCase() === 'POST';
          return OriginalApptXhrOpen.apply(this, arguments);
        };
        var OriginalApptXhrSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (body) {
          if (this.__grenadineIsCartAddForApptTimer && body) {
            if (typeof FormData !== 'undefined' && body instanceof FormData) {
              injectExpiryIntoFormData(body);
            } else if (typeof body === 'string') {
              var newBody = injectExpiryIntoJsonBody(body);
              if (newBody) { body = newBody; }
            }
          }
          return OriginalApptXhrSend.call(this, body);
        };
      }

      function formatRemaining(ms) {
        var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      }

      var removingKeys = {};

      function removeExpiredLine(lineKey) {
        if (removingKeys[lineKey]) { return; }
        removingKeys[lineKey] = true;
        /* on garde le soin concerne (lien + nom) pour le bouton "Reprendre rendez-vous" de la pop-up */
        var info = { url: '/pages/nos-prestations', title: '' };
        var tEl = document.querySelector('[data-appt-timer][data-line-key="' + lineKey + '"]');
        var row = tEl && tEl.closest('.cart__items__row');
        var lnk = row && row.querySelector('.cart__items__title a[href*="/products/"], a[href*="/products/"]');
        if (lnk) { info.url = lnk.getAttribute('href').split('?')[0]; info.title = (lnk.textContent || '').trim().split(' - ')[0]; }
        window.__grExpiredInfo = info;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        })
          .then(function (res) { if (!res.ok) { throw new Error('change ' + res.status); } return res.json(); })
          .then(function (cart) {
            var still = (cart.items || []).some(function (it) { return it.key === lineKey; });
            if (still) { throw new Error('still in cart'); }
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
            /* au cas ou le tiroir ne se redessine pas : la ligne expiree disparait de l'affichage */
            document.querySelectorAll('[data-appt-timer][data-line-key="' + lineKey + '"]').forEach(function (t) { var row = t.closest('.cart__items__row'); if (row) { row.style.transition = 'opacity .3s ease'; row.style.opacity = '0'; setTimeout(function () { row.remove(); }, 320); } });
            showExpiryNotice();
          })
          .catch(function () {
            /* echec (cle de ligne changee, reseau...) : on retrouve la ligne dans le panier actuel et on reessaie */
            setTimeout(function () {
              fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
                var gone = !(cart.items || []).some(function (it) { return it.key === lineKey; });
                if (gone) {
                  document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
                  document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
                  showExpiryNotice();
                } else { delete removingKeys[lineKey]; }
              }).catch(function () { delete removingKeys[lineKey]; });
            }, 1500);
          });
      }

      function showExpiryNotice() {
        if (document.getElementById('grenadine-appt-expired-notice')) { return; }
        var ex = window.__grExpiredInfo || { url: '/pages/nos-prestations', title: '' };
        closeApptHoldModal();
        var overlay = document.createElement('div');
        overlay.className = 'grenadine-appt-modal-overlay';
        overlay.id = 'grenadine-appt-expired-notice';
        overlay.innerHTML =
          '<div class="grenadine-appt-modal" role="dialog" aria-modal="true" aria-label="Créneau expiré">' +
            '<button type="button" class="grenadine-appt-modal__close" aria-label="Fermer"></button>' +
            '<p class="gam-label">Votre rendez-vous</p>' +
            '<h3 class="grenadine-appt-modal__title"><b>Créneau expiré</b><i>pas de panique</i></h3>' +
            '<div class="gam-timer gam-timer--off"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></svg><span>Temps de réservation dépassé</span><strong>0:00</strong></div>' +
            '<p class="grenadine-appt-modal__text">Ce créneau ' + (ex.title ? 'pour votre <b>' + ex.title + '</b> ' : '') + 'n’est plus réservé pour vous, il a donc été <b>retiré de votre panier</b>. Choisissez un nouveau créneau, il vous attend 🩷</p>' +
            '<a class="gam-ok" href="' + ex.url + '">Reprendre rendez-vous</a>' +
            '<button type="button" class="gam-later">Plus tard</button>' +
          '</div>';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay || e.target.closest('.grenadine-appt-modal__close') || e.target.closest('.gam-later')) { overlay.remove(); }
        });
      }

      function updateTimers() {
        var timers = document.querySelectorAll('[data-appt-timer]');
        for (var i = 0; i < timers.length; i++) {
          var el = timers[i];
          var expiresAt = parseInt(el.getAttribute('data-expires-at'), 10);
          var lineKey = el.getAttribute('data-line-key');
          if (!expiresAt || !lineKey) { continue; }

          var remaining = expiresAt - Date.now();
          var valueEl = el.querySelector('[data-appt-timer-value]');

          if (remaining <= 0) {
            if (valueEl) { valueEl.textContent = '0:00'; }
            removeExpiredLine(lineKey);
            continue;
          }

          if (valueEl) { valueEl.textContent = formatRemaining(remaining); }
          el.classList.toggle('cart__items__timer--danger', remaining <= 60000);
        }

        var modalOverlay = document.getElementById('grenadine-appt-modal-overlay');
        if (modalOverlay) {
          var modalRemaining = modalOverlay.__apptExpiresAt - Date.now();
          if (modalRemaining <= 0) {
            closeApptHoldModal();
          } else {
            var remainingEl = modalOverlay.querySelector('[data-appt-modal-remaining]');
            if (remainingEl) { remainingEl.textContent = formatRemaining(modalRemaining); }
          }
        }
      }

      
      function showApptHoldModal(expiresAt) {
        closeApptHoldModal();

        var overlay = document.createElement('div');
        overlay.className = 'grenadine-appt-modal-overlay';
        overlay.id = 'grenadine-appt-modal-overlay';
        overlay.__apptExpiresAt = expiresAt;
        overlay.innerHTML =
          '<div class="grenadine-appt-modal" role="dialog" aria-modal="true" aria-label="Créneau réservé">' +
            '<button type="button" class="grenadine-appt-modal__close" aria-label="Fermer"></button>' +
            '<p class="gam-label">Votre rendez-vous</p>' +
            '<h3 class="grenadine-appt-modal__title"><b>Créneau réservé</b><i>rien que pour vous</i></h3>' +
            '<div class="gam-timer"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></svg><span>Encore</span><strong data-appt-modal-remaining>' + formatRemaining(expiresAt - Date.now()) + '</strong></div>' +
            '<p class="grenadine-appt-modal__text">Ce créneau vous est réservé pendant ce temps. Passé ce délai, quelqu’un d’autre pourra le réserver et <b>il ne sera plus dans votre panier</b>.</p>' +
            '<button type="button" class="gam-ok">J’ai compris</button>' +
          '</div>';
        document.body.appendChild(overlay);

        overlay.addEventListener('click', function (e) {
          if (e.target === overlay || e.target.closest('.grenadine-appt-modal__close') || e.target.closest('.gam-ok')) {
            closeApptHoldModal();
          }
        });
      }

      function closeApptHoldModal() {
        var existing = document.getElementById('grenadine-appt-modal-overlay');
        if (existing) { existing.remove(); }
      }

      document.addEventListener('click', function (e) {
        var timerBtn = e.target.closest('[data-appt-timer]');
        if (timerBtn) {
          e.preventDefault();
          var expiresAt = parseInt(timerBtn.getAttribute('data-expires-at'), 10);
          if (expiresAt) { showApptHoldModal(expiresAt); }
        }
      });

      setInterval(updateTimers, 1000);
      updateTimers();
    })();
  
;
    (function () {
      if (window.__grenadineCartUpsellAddInstalled) { return; }
      window.__grenadineCartUpsellAddInstalled = true;

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-upsell-add]');
        if (!btn || btn.disabled) { return; }
        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) { return; }
        var sellingPlanId = btn.getAttribute('data-selling-plan-id');

        var payload = { items: [{ id: variantId, quantity: 1 }] };
        if (sellingPlanId) {
          payload.items[0].selling_plan = sellingPlanId;
        }

        btn.disabled = true;
        btn.classList.add('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            btn.disabled = false;
            btn.classList.remove('loading');
          })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('loading');
          });
      });
    })();
  
;
    /* Reservation Meety : apres "Reservez maintenant", on reste sur la page (le panier s'ouvre en tiroir)
       au lieu d'etre envoye sur la page /cart. Reglage Meety "confirmActionType" : 0 = aller au panier, 1 = ajouter au panier. */
    (function () {
      function patch() { try { (window.MeetyInitData.widgets.widgets || []).forEach(function (w) { if (w && w.textSettings) { w.textSettings.confirmActionType = 1; } }); } catch (e) {} }
      patch(); document.addEventListener('DOMContentLoaded', patch); window.addEventListener('load', patch);
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.meety-block-button, [class*="meety"]')) patch(); }, true);
    })();
  
;
    (function () {
      if (window.__grenadineMeetyWatcherInstalled) { return; }
      window.__grenadineMeetyWatcherInstalled = true;

      var POLL_INTERVAL_MS = 1500;
      var MAX_POLL_MS = 10 * 60 * 1000;

      function getCartUrl() {
        return ((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart') + '.js';
      }

      function fetchItemCount() {
        return fetch(getCartUrl())
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            return (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
          })
          .catch(function () { return null; });
      }

      function triggerDrawerRefresh() {
        if (typeof window.__grenadineRefreshCartDrawer === 'function') {
          window.__grenadineRefreshCartDrawer();
          return;
        }
        fetch(getCartUrl())
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
            var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          })
          .catch(function () {});
      }

      function watchMeetyModal(modalEl) {
        var stopped = false;
        var startTime = Date.now();
        var baselineCount = null;

        function poll() {
          if (stopped) { return; }
          if (Date.now() - startTime > MAX_POLL_MS) {
            stopped = true;
            return;
          }
          var stillOpen = document.body.contains(modalEl);
          fetchItemCount().then(function (count) {
            if (stopped) { return; }
            if (baselineCount !== null && count !== null && count > baselineCount) {
              stopped = true;
              triggerDrawerRefresh();
              return;
            }
            if (!stillOpen) {
              stopped = true;
              return;
            }
            setTimeout(poll, POLL_INTERVAL_MS);
          });
        }

        fetchItemCount().then(function (count) {
          baselineCount = count;
          setTimeout(poll, POLL_INTERVAL_MS);
        });
      }

      function looksLikeMeetyModal(node) {
        if (!node || node.nodeType !== 1) { return null; }
        if (node.matches && node.matches('.meety-modal-overlay')) { return node; }
        if (node.querySelector) {
          var inner = node.querySelector('.meety-modal-overlay');
          if (inner) { return inner; }
        }
        return null;
      }

      function startObserving() {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var modalEl = looksLikeMeetyModal(added[j]);
              if (modalEl) {
                watchMeetyModal(modalEl);
              }
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      if (document.body) {
        startObserving();
      } else {
        document.addEventListener('DOMContentLoaded', startObserving);
      }
    })();
  
;
